
import React, {useState, useEffect} from 'react'
import './Home.css';

import AddFamilyModal from './AddFamilyModal'
import Family from './Family'
import RelativeFamily from './RelativeFamily';
import FamilyCardView from './FamilyCardView';

// DB
import { db, auth } from '../utils/User/include/Authorize'
import { useStateValue } from '../utils/Provider/StateProvider';
import { useHistory } from 'react-router-dom';

function Home() {
    const history = useHistory()

    const [{ user, myrelative, myfamily}, dispatch] = useStateValue();
    const [familyModal, displayFamilyModal] = useState(false)
    const [RelativefamilyModal, displayRelativeFamilyModal] = useState(false);

    const [cardView, setCardView] = useState(true);
    const [personView, setPersonView] = useState(false)

    const switchView = (view) => {
        
        switch(view){
            case 'PERSON_VIEW':
                setCardView(false)
                setPersonView(true)
                return
            
            case 'CARD_VIEW':
                setCardView(true)
                setPersonView(false)
                return
            
            default:
                console.log("Error ",view)
                break
            
        }
    }

  return (
    <div className='home_container'>
        <div className='home_img_container'>
            <img className='home_background_img' src={require('../resources/family_home_2k_1k1.png')} alt='home' />
        </div>

        <div className='home_container_description'>
            <h1>Better Together,Gather Together</h1>
            <h1>Stay Together as Family is Forever</h1>


            <br />
            <h4>Connect Every-One closest to You</h4>

            <button className='home_container_start_btn'>Get Started</button>
        </div>


        <section className='home_container_help'>
            <div className='home_container_help_quick'>
                <p className='home_container_help_quick_title'>How to Do</p>
                <br />
                <img className='home_container_help_quick_icon' src={require("../resources/confuse.png")} alt='icon' />

                <div className='home_container_help_hint no-display'>
                    You can go to create part and add your creation of family.
                     You need to create your personal family
                </div>

            </div>
            
            <div className='home_container_help_quick'>
                <p className='home_container_help_quick_title'>What to do</p>
                <br />
                <img className='home_container_help_quick_icon' src={require("../resources/work.png")} alt='icon' />

                <div className='home_container_help_hint no-display'>
                    You can go to create part and add your creation of family.
                     You need to create your personal family
                </div>
            </div>

            <div className='home_container_help_quick'>
                <p className='home_container_help_quick_title'>How will This work</p>
                <br />
                <img className='home_container_help_quick_icon' src={require("../resources/idea.png")} alt='icon' />
                
                <div className='home_container_help_hint no-display'>
                    You can go to create part and add your creation of family.
                     You need to create your personal family
                </div>
            </div>
        </section>

        <br />
        <br />
        <br />
        <hr />

        <section className='home_container_create_family'>
            <div>
                <h1>Your Family</h1>


                <div className='home_container_create_family_cardView'>

                    {myfamily ?
                        <Family />
                        :
                        <div className='home_container_create_family_button' onClick={() => displayFamilyModal(true)}>
                            <p className='home_container_create_family_button_title'>Add to your Family</p>
                            
                            <br />
                            <img className='home_container_create_family_button_icon' src={require('../resources/add.png')} alt="add family" />
                        </div>
                    }
                </div>





                { familyModal ?
                    <div className='addfamily_modal_toggle'>
                         
                        <div className='addfamily_modal_close' onClick={() => displayFamilyModal(false)}></div>
                        <AddFamilyModal type='my_family' onCloseHandler={() => displayFamilyModal(false)} />
                    </div>
                :
                    null
                }
                
                
            </div>
        </section>

        <hr />

        
        {user && 
            <div className='home_container_family_viewManager'>

            {myrelative &&
                <div className='home_container_family_viewCard' onClick={() => switchView('PERSON_VIEW')} 
                    style={personView ? 
                            {border: '2px solid rgb(20, 202, 20)',
                            backgroundImage: "url('https://t3.ftcdn.net/jpg/00/85/85/44/240_F_85854467_U7aYM3pcI2vU5yaR4JeJdrcQ5NhyD87X.jpg')",
                            backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'
                        } 
                        : 
                            {backgroundImage: "url('https://t3.ftcdn.net/jpg/00/85/85/44/240_F_85854467_U7aYM3pcI2vU5yaR4JeJdrcQ5NhyD87X.jpg')",
                                backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'
                            }
                        }
                
                >
                    <h5>Family View</h5>
                </div>  
            }

            {myrelative &&
                <div className='home_container_family_viewCard' onClick={() => switchView('CARD_VIEW')}  
                    style={cardView ? 
                            {
                                border: '2px solid rgb(20, 202, 20)',
                                backgroundImage: "url('https://files.123freevectors.com/wp-content/original/131648-pink-blue-and-white-polygonal-abstract-background-design.jpg')",
                                backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'
                            }
                    : 
                        {backgroundImage: "url('https://files.123freevectors.com/wp-content/original/131648-pink-blue-and-white-polygonal-abstract-background-design.jpg')",
                        backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'
                    }}
                >
                    <h5>Card View</h5>
                </div>  
            }

            {myrelative && 
                <div className='home_container_family_viewCard' onClick={() => history.push('/tree')}
                    style={{backgroundImage: "url('https://www.printawallpaper.com/wp-content/uploads/2013/08/Blue_White_Polygonal_Mosaic_d.jpg')",
                        backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'
                    }}
                >
                    <h5>Tree View</h5>
                </div>
            }    


            {myrelative && 
                <div className='home_container_family_viewCard' onClick={() => history.push('/person/individualView')} 
                    style={{backgroundImage: "url('https://files.123freevectors.com/wp-content/original/130970-blue-and-white-polygon-background.jpg')",
                        backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'
                    }}
                >
                    <h5>Person View</h5>
                </div>
            } 
            
            {myrelative && 
                <div className='home_container_family_viewCard' onClick={() => history.push('/link/family')} 
                    style={{backgroundImage: "url('https://cdn.wallpapersafari.com/61/98/v3mUal.jpg')",
                        backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'
                    }}
                >
                    <h5>Link Families</h5>
                </div>
            }
            </div>
        }

        <br />
        <section className='home_container_create_family'>
            <div>
                <h1>Relatives</h1>
        

                

                { RelativefamilyModal ?
                    <div className='addfamily_modal_toggle'>
                            
                        <div className='addfamily_modal_close' onClick={() => displayRelativeFamilyModal(false)}></div>
                        <AddFamilyModal type='my_relative' onCloseHandler={() => displayRelativeFamilyModal(false)} />
                    </div>
                :
                    null
                }

                { personView && myrelative ?
                    <RelativeFamily />
                    
                
                :
                    null
                }

                { cardView && myrelative ?
                    <FamilyCardView />
                :
                    null
                }

                { myrelative ?
                    null
                :

                myfamily?

                <div className='home_container_create_family_button' onClick={() => displayRelativeFamilyModal(true)}>
                    <p className='home_container_create_family_button_title'>Add to your Relatives</p>
                    
                    <br />
                    <img className='home_container_create_family_button_icon' src={require('../resources/add.png')} alt="add family" />
                </div>:

                <div className='home_container_create_family_button' onClick={() => displayFamilyModal(true)}>
                    <p className='home_container_create_family_button_title'>Add to your Family</p>
                    
                    <br />
                    <img className='home_container_create_family_button_icon' src={require('../resources/add.png')} alt="add family" />
                </div>
                }

            </div>
        </section>

    </div>
  )
}

export default Home